import React from 'react';
import styles from './Style.module.css';
import { useBookingTimer } from '../../Context/Timer/useBookingTimer';

const Timer = ({ customClass = '' }) => {
  const {
    timeLeft,
    isTimerActive,
  } = useBookingTimer();

  const formatTime = (seconds) => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${mins}:${secs}`;
  };

  const [minutes, seconds] = formatTime(timeLeft).split(':');

  return (
    <>
      {isTimerActive && (
        <div
          className={`${styles.timer} ${customClass} ${
            timeLeft <= 180 ? styles.danger : ''
          }`}
        >
          <div className={`${styles.timerContainer} space-x container`}>
            <div className={styles.left}>Slots held for</div>
            <div className={styles.right}>
              <span className={styles.min}>{minutes}</span>
              <span className={styles.col}>:</span>
              <span className={styles.sec}>{seconds}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Timer;
